import { IApplicationState } from 'shared/types/redux';

export const selectSeoRichText = (state: IApplicationState) => state.landing.seoData?.richText ?? null;
